export default "__VITE_ASSET__mtd9pxhF__"